// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"dca-z","inlineTitle":"eca-z","sponsoredAdsWrapper":"fca-z","marketplaceRecosWrapper":"gca-z","brandShopTheLookWrapper":"hca-z"};